import { useModalContext } from '@/contexts/ModalContext';
import { Button } from '../ui/Button';

// TODO: change to use tailwind classes
export default function AuthButtons() {
  const { openLoginModal, openSignupModal } = useModalContext();

  return (
    <>
      <Button onClick={openLoginModal} variant="secondary" className="w-[68px] h-[39px] border border-[#E5E7EB]">
        <span className="text-[#113D7B] font-medium">Login</span>
      </Button>
      <Button onClick={openSignupModal} variant="primary" className="w-[125px] h-[40px] border border-[#F4F4F4]">
        Join Equipool
      </Button>
    </>
  );
}
